import { Injectable } from '@angular/core';
import { map, pluck, distinct } from 'rxjs/operators';
import { from, Subject, Observable, of, timer, forkJoin, Subscription } from 'rxjs';

@Injectable()
export class RxMethods {

  map(response) {
    return response.pipe(map((data) => data));
  }

  pluck(data, field) {
    const filteredData = [];
    if (data) {
      from(data).pipe(pluck(field)).subscribe(
        (response) => {
          if (response) {
            filteredData.push(response);
          }
        }
      );
    }
    return filteredData;
  }

  deepCopy(data: any, type: any) {
    return data.map((item: any) => Object.assign(type, item));
  }

  createSubjectService() {
    return new Subject<any>();
  }

  createObservable() {
    return new Observable<any>();
  }

  createSubscription() {
    return new Subscription();
  }

  pluckAsDate(data: object[], field: string) {
    const filteredData = [];
    // const dates = data.from(new Set(field));
    // from(data).pipe(pluck(field)).subscribe(
    //   (response) => {
    //     if (response) {
    //       filteredData.push(new Date(response));
    //     }
    //   }
    // );
    return filteredData;
  }

  unique(data: object[], field?: string) {
    if (field) {
      of(data).pipe(
        distinct((elem) => elem[field]),
      ).subscribe(x =>
        console.log(x)
      );
    } else {
      of(data).pipe(
        distinct(),
      ).subscribe(x =>
        console.log(x)
      );
    }
    return data;
  }

  timer(seconds) {
    return timer(seconds);
  }

  forkJoin(requests) {
    return forkJoin(requests);
  }
}
